module.exports = __webpack_public_path__ + "static/img/customer.83b7d98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customer.png
// module id = T/cd
// module chunks = 1